import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.assign.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import $ from 'zepto';
import axios from 'axios';
import { channelPageArtsInfoUrl } from '@/apis';
import TourItem from './TourItem.vue';
import { WishCitiesPopup } from 'comp/artist';
import throttle from '@/utils/throttle';
import { cancelWish, addWish } from '@/apis/index';
import Drip from 'drip';
import KNB from '@dp/knb';
var CODE_MAP = {
  1414: '前方拥堵 请刷新重试',
  1407: '前方拥堵 请刷新重试',
  403: '请先登录。'
};
$.fn.scrollL = function (options) {
  var defaults = {
    toLeft: 0,
    // 滚动目标位置
    durTime: 500,
    // 过渡动画时间
    callback: null,
    // 回调函数
    minMoveThreshold: 1 // 每帧最小更新阈值
  };

  var opts = $.extend(defaults, options);
  var _this = this;
  var startLeft = _this.scrollLeft(); // 当前滚动条位置
  var changeLeft = opts.toLeft - startLeft; // 目标位置与当前滚动位置的差值
  var startTime = null; // 动画开始时间
  var lastLeft = startLeft; // 上一次滚动位置

  // 动画函数
  var animateScroll = function animateScroll(timestamp) {
    if (!startTime) startTime = timestamp; // 初始化开始时间
    var timeElapsed = timestamp - startTime; // 当前已过时间
    var progress = Math.min(timeElapsed / opts.durTime, 1); // 计算动画进度

    // 计算新的滚动位置
    var newLeft = startLeft + changeLeft * progress;

    // 使用最小移动阈值来减少更新频率
    if (Math.abs(newLeft - lastLeft) > opts.minMoveThreshold) {
      newLeft = Math.round(newLeft);
      _this.scrollLeft(newLeft);
      lastLeft = newLeft; // 更新滚动位置
    }

    if (progress < 1) {
      requestAnimationFrame(animateScroll);
    } else {
      // 动画完成，执行回调函数
      if (opts.callback && typeof opts.callback === 'function') {
        opts.callback();
      }
    }
  };

  // 启动动画
  requestAnimationFrame(animateScroll);
  return _this;
};
export default {
  name: 'ArtistListNew',
  props: {
    list: {
      type: Array,
      default: []
    },
    categoryId: {
      type: [String, Number],
      default: ''
    },
    mistiming: {
      type: Number,
      default: 0
    }
  },
  components: {
    TourItem: TourItem,
    WishCitiesPopup: WishCitiesPopup
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this2.getGCi();
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  mounted: function mounted() {
    var _this$$refs, _this$$refs$homepageA, _this$$refs2, _this$$refs2$homepage, _this$$refs3, _this$$refs3$homepage;
    this.throttleOnscroll = throttle(this.handleScroll, 150);
    (_this$$refs = this.$refs) === null || _this$$refs === void 0 ? void 0 : (_this$$refs$homepageA = _this$$refs.homepageArtistList) === null || _this$$refs$homepageA === void 0 ? void 0 : _this$$refs$homepageA.addEventListener('scroll', this.throttleOnscroll);
    (_this$$refs2 = this.$refs) === null || _this$$refs2 === void 0 ? void 0 : (_this$$refs2$homepage = _this$$refs2.homepageArtistList) === null || _this$$refs2$homepage === void 0 ? void 0 : _this$$refs2$homepage.addEventListener('scroll', window.StatusReportData, false);
    (_this$$refs3 = this.$refs) === null || _this$$refs3 === void 0 ? void 0 : (_this$$refs3$homepage = _this$$refs3.homepageTourWrapper) === null || _this$$refs3$homepage === void 0 ? void 0 : _this$$refs3$homepage.addEventListener('scroll', window.StatusReportData, false);
    var artistContainerWrapper = document.querySelector('.artist-list-new-wrap');
    var computedStyle = window.getComputedStyle(artistContainerWrapper);
    var processedMarginRight = this.processMargin(computedStyle === null || computedStyle === void 0 ? void 0 : computedStyle.marginRight);
    var processedMarginLeft = this.processMargin(computedStyle === null || computedStyle === void 0 ? void 0 : computedStyle.marginLeft);
    artistContainerWrapper.style.marginRight = "".concat(processedMarginRight, "px");
    artistContainerWrapper.style.marginLeft = "".concat(processedMarginLeft, "px");
  },
  destroyed: function destroyed() {
    var _this$$refs4, _this$$refs4$homepage, _this$$refs5, _this$$refs5$homepage, _this$$refs6, _this$$refs6$homepage;
    (_this$$refs4 = this.$refs) === null || _this$$refs4 === void 0 ? void 0 : (_this$$refs4$homepage = _this$$refs4.homepageArtistList) === null || _this$$refs4$homepage === void 0 ? void 0 : _this$$refs4$homepage.removeEventListener('scroll', this.throttleOnscroll);
    (_this$$refs5 = this.$refs) === null || _this$$refs5 === void 0 ? void 0 : (_this$$refs5$homepage = _this$$refs5.homepageArtistList) === null || _this$$refs5$homepage === void 0 ? void 0 : _this$$refs5$homepage.removeEventListener('scroll', window.StatusReportData, false);
    (_this$$refs6 = this.$refs) === null || _this$$refs6 === void 0 ? void 0 : (_this$$refs6$homepage = _this$$refs6.homepageTourWrapper) === null || _this$$refs6$homepage === void 0 ? void 0 : _this$$refs6$homepage.removeEventListener('scroll', window.StatusReportData, false);
  },
  data: function data() {
    return {
      activeIndex: 0,
      performance: {},
      cacheData: {},
      tourGroupProjectVoList: [],
      isShowLeftBorder: true,
      isShowLeftTopBorder: false,
      isShowCity: false,
      gCi: undefined
      // isShowLeftMask: false,
      // isShowRightMask: true,
    };
  },

  methods: {
    processMargin: function processMargin(marginStr) {
      var marginNum = parseFloat(marginStr);
      var integerPart = Math.floor(marginNum);
      var decimalPart = marginNum - integerPart;
      var newDecimalPart;
      if (decimalPart > 0 && decimalPart < 0.25) {
        newDecimalPart = 0;
      } else if (decimalPart >= 0.25 && decimalPart < 0.75) {
        newDecimalPart = 0.5;
      } else if (decimalPart >= 0.75) {
        newDecimalPart = 1;
      }
      return integerPart + newDecimalPart;
    },
    handleShouldShowLeftBorder: function handleShouldShowLeftBorder(activeEleDistanceToLeft, leftBorderMinDistance, leftBorderMaxDistance) {
      if (leftBorderMinDistance <= activeEleDistanceToLeft && activeEleDistanceToLeft <= leftBorderMaxDistance || activeEleDistanceToLeft < 0) {
        this.isShowLeftBorder = false;
      } else {
        this.isShowLeftBorder = true;
      }
    },
    handleShouldShowLeftTopBorder: function handleShouldShowLeftTopBorder(activeEleDistanceToLeft, leftTopRadiusMaxDistance, activeEleDistanceToRight, leftTopRadiusMinDistance) {
      if (leftTopRadiusMaxDistance <= activeEleDistanceToLeft || activeEleDistanceToRight <= leftTopRadiusMinDistance) {
        this.isShowLeftTopBorder = true;
      } else {
        this.isShowLeftTopBorder = false;
      }
    },
    // handleShouldShowLeftMask(activeEleDistanceToLeft, firstEleDistanceToLeft, activeEleDistanceToRight, leftMaskDistance, ratio) {
    //   if (Math.ceil(firstEleDistanceToLeft) < Math.ceil(leftMaskDistance) &&
    //   ( activeEleDistanceToLeft > (ratio * 50) || activeEleDistanceToRight < (ratio * 12))) {
    //     this.isShowLeftMask = true
    //   } else {
    //     this.isShowLeftMask = false
    //   }
    // },
    // handleShouldShowRightMask(activeEleDistanceToLeft, activeEleDistanceToRight, lastEleDistanceToLeft, rightMaskDistance, screenWidth, ratio) {
    //   if (Math.ceil(lastEleDistanceToLeft) > (Math.ceil(rightMaskDistance) + 2) &&
    //   ((screenWidth - activeEleDistanceToRight > ratio * 50) || (
    //     activeEleDistanceToLeft > screenWidth - (ratio * 12)
    //   ))
    //   ) {
    //     this.isShowRightMask = true
    //   } else {
    //     this.isShowRightMask = false
    //   }
    // },
    getDistanceParams: function getDistanceParams() {
      var _document$getElements, _document$getElements2, _window$screen;
      var activeEleRect = (_document$getElements = document.getElementsByClassName('icon-item-active-homepage')) === null || _document$getElements === void 0 ? void 0 : (_document$getElements2 = _document$getElements[0]) === null || _document$getElements2 === void 0 ? void 0 : _document$getElements2.getBoundingClientRect();
      var activeEleDistanceToLeft = activeEleRect === null || activeEleRect === void 0 ? void 0 : activeEleRect.left;
      var activeEleDistanceToRight = activeEleRect === null || activeEleRect === void 0 ? void 0 : activeEleRect.right;
      var screenWidth = (_window$screen = window.screen) === null || _window$screen === void 0 ? void 0 : _window$screen.width;
      var ratio = screenWidth / 375;
      var leftBorderMaxDistance = ratio * 16;
      var leftBorderMinDistance = ratio * 11;
      var leftTopRadiusMaxDistance = ratio * 27;
      var leftTopRadiusMinDistance = ratio * 8;

      // const leftMaskDistance = ratio * 12
      // const rightMaskDistance = ratio * 318
      // const firstEleDistanceToLeft = document.getElementsByClassName('art0')[0]?.getBoundingClientRect()?.left;
      // const lastEleDistanceToLeft = document.getElementsByClassName(`art${this.list?.length - 1}`)?.[0]?.getBoundingClientRect()?.left;

      return {
        activeEleDistanceToLeft: activeEleDistanceToLeft,
        activeEleDistanceToRight: activeEleDistanceToRight,
        screenWidth: screenWidth,
        ratio: ratio,
        leftBorderMaxDistance: leftBorderMaxDistance,
        leftBorderMinDistance: leftBorderMinDistance,
        leftTopRadiusMaxDistance: leftTopRadiusMaxDistance,
        leftTopRadiusMinDistance: leftTopRadiusMinDistance

        // leftMaskDistance,
        // rightMaskDistance,
        // firstEleDistanceToLeft,
        // lastEleDistanceToLeft
      };
    },

    handleScroll: function handleScroll() {
      var _this$getDistancePara = this.getDistanceParams(),
        activeEleDistanceToLeft = _this$getDistancePara.activeEleDistanceToLeft,
        activeEleDistanceToRight = _this$getDistancePara.activeEleDistanceToRight,
        leftBorderMaxDistance = _this$getDistancePara.leftBorderMaxDistance,
        leftBorderMinDistance = _this$getDistancePara.leftBorderMinDistance,
        leftTopRadiusMaxDistance = _this$getDistancePara.leftTopRadiusMaxDistance,
        leftTopRadiusMinDistance = _this$getDistancePara.leftTopRadiusMinDistance;

      // 选中元素左边弧度展示逻辑 选中元素左边距视口左边距离大于11并且小于16 不展示
      this.handleShouldShowLeftBorder(activeEleDistanceToLeft, leftBorderMinDistance, leftBorderMaxDistance);

      // 下方左上圆角展示逻辑 选中元素左边距视口左边距离大于27或者元素右边距视口左边距离小于8 展示
      this.handleShouldShowLeftTopBorder(activeEleDistanceToLeft, leftTopRadiusMaxDistance, activeEleDistanceToRight, leftTopRadiusMinDistance);

      // // 最左蒙层展示逻辑
      // this.handleShouldShowLeftMask(activeEleDistanceToLeft, firstEleDistanceToLeft, activeEleDistanceToRight, leftMaskDistance, ratio)

      // // 最右蒙层展示逻辑
      // this.handleShouldShowRightMask(activeEleDistanceToLeft, activeEleDistanceToRight, lastEleDistanceToLeft, rightMaskDistance, screenWidth, ratio)
    },

    handleChangeTourStatus: function handleChangeTourStatus(obj) {
      this.$emit('changeSaleStatus', obj);
    },
    // 查看更多
    goArtistInfo: function goArtistInfo() {
      var _this$list;
      var _ref = ((_this$list = this.list) === null || _this$list === void 0 ? void 0 : _this$list[this === null || this === void 0 ? void 0 : this.activeIndex]) || {},
        jumpUrl = _ref.jumpUrl,
        celebritySchemaUrl = _ref.celebritySchemaUrl;
      if (!celebritySchemaUrl) return;
      if (Drip.UA.isNative) {
        KNB.openPage({
          url: celebritySchemaUrl
        });
      } else {
        this.go(celebritySchemaUrl, {
          _blank: true
        });
      }
    },
    handleChooseItem: function handleChooseItem(index) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this3$list, _artistNameElement$cl, _artistNameElement$cl2, _artistNameElement$cl3, _this3$list2, _this3$list2$index, _this3$cacheData;
        var _ref2, celebrityId, animateName, artistNameElement, tourItemElements, addButtonElements, params, str, _this3$cacheData2, _yield$axios$get, data;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(index === _this3.activeIndex)) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return", _this3.goArtistInfo());
            case 2:
              _ref2 = ((_this3$list = _this3.list) === null || _this3$list === void 0 ? void 0 : _this3$list[index]) || {}, celebrityId = _ref2.celebrityId;
              window.seedAction({
                evt: 'click',
                bid: 'b_movie_eundh7k9_mc',
                celebrity_id: celebrityId,
                index: index,
                category_id: '1',
                needTag: true
              });

              // tour-wrapper复位
              $('.tour-wrapper').scrollL({
                toLeft: 0,
                durTime: 0
              });
              animateName = index > _this3.activeIndex ? 'animate-right' : 'animate-left';
              _this3.activeIndex = index;
              _this3.$nextTick(function () {
                var _document$getElements3, _document$getElements4, _activeElement$getBou, _firstElement$getBoun, _document$getElementB;
                var activeElement = (_document$getElements3 = document.getElementsByClassName("homepageArt".concat(index))) === null || _document$getElements3 === void 0 ? void 0 : _document$getElements3[0];
                var firstElement = (_document$getElements4 = document.getElementsByClassName("homepageArt".concat(0))) === null || _document$getElements4 === void 0 ? void 0 : _document$getElements4[0];
                var scrollDistance = (activeElement === null || activeElement === void 0 ? void 0 : (_activeElement$getBou = activeElement.getBoundingClientRect()) === null || _activeElement$getBou === void 0 ? void 0 : _activeElement$getBou.left) - (firstElement === null || firstElement === void 0 ? void 0 : (_firstElement$getBoun = firstElement.getBoundingClientRect()) === null || _firstElement$getBoun === void 0 ? void 0 : _firstElement$getBoun.left);
                var decimalPart = scrollDistance - Math.floor(scrollDistance);
                if (decimalPart >= 0.5) {
                  decimalPart = decimalPart - 0.5;
                }
                (_document$getElementB = document.getElementById('artist-list')) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.scroll({
                  left: decimalPart >= 0.25 ? scrollDistance + 0.5 : scrollDistance,
                  behavior: 'smooth'
                });
                _this3.handleScroll();
              });
              artistNameElement = document.getElementById('artistName');
              (_artistNameElement$cl = artistNameElement.classList) === null || _artistNameElement$cl === void 0 ? void 0 : _artistNameElement$cl.remove('animate-right');
              (_artistNameElement$cl2 = artistNameElement.classList) === null || _artistNameElement$cl2 === void 0 ? void 0 : _artistNameElement$cl2.remove('animate-left');
              artistNameElement.offsetHeight;
              (_artistNameElement$cl3 = artistNameElement.classList) === null || _artistNameElement$cl3 === void 0 ? void 0 : _artistNameElement$cl3.add(animateName);
              tourItemElements = document.querySelectorAll('.tour-item');
              addButtonElements = document.querySelectorAll('.add-city-button');
              tourItemElements.forEach(function (element) {
                var _element$classList, _element$classList2, _element$classList3;
                (_element$classList = element.classList) === null || _element$classList === void 0 ? void 0 : _element$classList.remove('animate-right');
                (_element$classList2 = element.classList) === null || _element$classList2 === void 0 ? void 0 : _element$classList2.remove('animate-left');
                element.offsetHeight; // 触发重新渲染，确保动画能够重新执行
                (_element$classList3 = element.classList) === null || _element$classList3 === void 0 ? void 0 : _element$classList3.add(animateName); // 重新添加动画类
              });

              addButtonElements.forEach(function (element) {
                var _element$classList4, _element$classList5, _element$classList6;
                (_element$classList4 = element.classList) === null || _element$classList4 === void 0 ? void 0 : _element$classList4.remove('animate-right');
                (_element$classList5 = element.classList) === null || _element$classList5 === void 0 ? void 0 : _element$classList5.remove('animate-left');
                element.offsetHeight; // 触发重新渲染，确保动画能够重新执行
                (_element$classList6 = element.classList) === null || _element$classList6 === void 0 ? void 0 : _element$classList6.add(animateName); // 重新添加动画类
              });

              params = {
                categoryId: _this3.categoryId,
                celebrityId: (_this3$list2 = _this3.list) === null || _this3$list2 === void 0 ? void 0 : (_this3$list2$index = _this3$list2[index]) === null || _this3$list2$index === void 0 ? void 0 : _this3$list2$index.celebrityId
              };
              str = JSON.stringify(params);
              if (!((_this3$cacheData = _this3.cacheData) !== null && _this3$cacheData !== void 0 && _this3$cacheData[str])) {
                _context2.next = 21;
                break;
              }
              return _context2.abrupt("return", _this3.performance = (_this3$cacheData2 = _this3.cacheData) === null || _this3$cacheData2 === void 0 ? void 0 : _this3$cacheData2[str]);
            case 21:
              _context2.prev = 21;
              _context2.next = 24;
              return axios.get(channelPageArtsInfoUrl, {
                params: params
              });
            case 24:
              _yield$axios$get = _context2.sent;
              data = _yield$axios$get.data;
              _context2.next = 30;
              break;
            case 28:
              _context2.prev = 28;
              _context2.t0 = _context2["catch"](21);
            case 30:
              _this3.cacheData[str] = _this3.performance;
            case 31:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[21, 28]]);
      }))();
    },
    // 查看更多
    handleItemClick: function handleItemClick() {
      var _this$list2;
      var _ref3 = ((_this$list2 = this.list) === null || _this$list2 === void 0 ? void 0 : _this$list2[this.activeIndex]) || {},
        jumpUrl = _ref3.jumpUrl,
        celebrityId = _ref3.celebrityId;
      window.lxTagReport('c_6yPP8', 'b_movie_mpfq12r1_mc', {
        celebrity_id: celebrityId
      });
      window.seedAction({
        evt: 'click',
        bid: 'b_movie_mpfq12r1_mc',
        custom: {
          celebrity_id: celebrityId
        }
      });
      if (!jumpUrl) return;
      this.go(jumpUrl, {
        _blank: true
      });
    },
    toAddCity: function toAddCity() {
      var _this$list3;
      var _ref4 = ((_this$list3 = this.list) === null || _this$list3 === void 0 ? void 0 : _this$list3[this.activeIndex]) || {},
        celebrityId = _ref4.celebrityId;
      window.seedAction({
        bid: 'b_movie_et644x0l_mc',
        celebrity_id: celebrityId
      });
      this.isShowCity = true;
    },
    getGCi: function getGCi() {
      // 安卓拼接参数
      this.gCi = this.$route.query.gCi;
    },
    onChangeCity: function onChangeCity(data) {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _this4$list, id, _ref5, celebrityId, tourInfoVo, _ref6, tourId, payload;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              try {
                if (data && data.id) {
                  id = data.id;
                  _ref5 = ((_this4$list = _this4.list) === null || _this4$list === void 0 ? void 0 : _this4$list[_this4.activeIndex]) || {}, celebrityId = _ref5.celebrityId, tourInfoVo = _ref5.tourInfoVo;
                  _ref6 = tourInfoVo || {}, tourId = _ref6.tourId;
                  payload = {
                    celebrityId: celebrityId || 0,
                    source: 4,
                    // 1演出艺人主页 2猫眼大搜 4首页艺人大咖
                    tourId: tourId || null,
                    // 巡演ID, 巡演加场有，想看无，默认null
                    wishCityId: id // 美团的城市id
                  };

                  _this4.onWish('add', payload);
                } else {
                  _this4.isShowCity = false;
                }
              } catch (error) {
                _this4.$owlReportError('首页-许愿失败', error);
              }
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    onWish: function onWish(type, payload) {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var res, _ref7, success, error, code, redirUrl;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return axios.post(type === 'add' ? addWish : cancelWish, Object.assign({}, payload));
            case 3:
              res = _context4.sent;
              _ref7 = (res === null || res === void 0 ? void 0 : res.data) || {}, success = _ref7.success, error = _ref7.error;
              if (success) {
                // 许愿成功之后消失弹窗
                _this5.isShowCity = false;

                // 更新一下
                if (type === 'add') {
                  _this5.$toast('想看成功，已为您反馈心愿', {
                    wordWrap: false
                  });
                }

                // knb通知
                _this5.onWishChange({
                  cityId: payload === null || payload === void 0 ? void 0 : payload.wishCityId,
                  wishStatus: type === 'add' ? 1 : 0,
                  celebrityId: payload === null || payload === void 0 ? void 0 : payload.celebrityId,
                  wishCardType: payload !== null && payload !== void 0 && payload.tourId ? 1 : 0 // wishCardType    0-许愿卡片  1-巡演卡片 ，默认值是0
                });
              } else {
                _this5.$toast(CODE_MAP[error === null || error === void 0 ? void 0 : error.code] || '前方拥堵 请稍后重试');
                code = error.code; // 需要登录
                if (code === 403) {
                  redirUrl = location.href;
                  if (_this5.isShowCity) {
                    // redirUrl+='&isAddCity=1'
                    // this.isShowCity = false
                  }
                  Drip.login({
                    redirUrl: redirUrl
                  }).then(function (user) {
                    _this5.isShowCity = true;
                  }).catch(function (err) {
                    console.warn(err);
                  });
                }
              }
              _context4.next = 11;
              break;
            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](0);
              _this5.$owlReportError("\u9996\u9875-".concat(type, "\u8BB8\u613F\u5931\u8D25"), _context4.t0);
            case 11:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[0, 8]]);
      }))();
    },
    onWishChange: function onWishChange(data) {
      try {
        if (Drip.UA.isNative && data) {
          KNB.publish({
            type: 'native',
            action: 'show_update_wish_status',
            data: data,
            fail: function fail() {},
            success: function success() {}
          });
        }
      } catch (error) {
        this.$owlReportError('首页-knb想看通知大搜失败', error);
      }
    }
  }
};